import Header from '../../Components/Header';
import Sidebar from '../../Components/Sidebar';
import CommitteesPage from './CommitteePage';

const Committee = () => {
  return (
    <div className="min-h-screen bg-app-background flex flex-col">
      <Header />

      <div className="flex flex-1  pt-[90px]">
        <Sidebar />

        <div className="flex-1 ml-[260px]">
          <CommitteesPage />
        </div>
      </div>
    </div>
  );
};

export default Committee;
